export default __webpack_public_path__ + "static/media/board-bg.fb99b354.png";